import { render } from "./APIDoc.vue?vue&type=template&id=bf18b3a4&scoped=true"
import script from "./APIDoc.vue?vue&type=script&lang=js"
export * from "./APIDoc.vue?vue&type=script&lang=js"

import "./APIDoc.vue?vue&type=style&index=0&id=bf18b3a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf18b3a4"]])

export default __exports__